import React, { memo, useRef } from "react";
// import {  useSelector } from "react-redux";
// import { createSelector } from "reselect";
// import { CheckboxChangeEvent } from "antd/lib/checkbox";
// import { RightOutlined } from "@ant-design/icons";
import {
	useNavigate,
	useLocation,
	// useSearchParams,
} from "react-router-dom";

// import { TStore } from "models";
// import { TermsAndConditionsModal } from "components";
// import { validateEmail } from "utils";
// import PrivacyPolicyModal from "components/PrivacyPolicyModal";
import LoginForm from "screens/login/components/Forms/loginForm";
// import FormContainer from "screens/login/components/SignIn";
import SignUpForm from "screens/login/components/Forms/signUpForm";
import ForgetPasswordForm from "screens/login/components/Forms/resetPasswordForm";
import ResetPasswordForm from "screens/login/components/Forms/resetPassword";

// const stateSelectorHandle = createSelector(
// 	(state: TStore) => state.auth.loading,
// 	(state: TStore) => state.auth.communityInvitation,
// 	(loading, communityInvitation) => ({ loading, communityInvitation }),
// );

const AuthenticationBox: React.FunctionComponent<{
	signUp?: boolean;
	forgotPassword?: boolean;
	resetPassword?: boolean;
}> = ({ signUp, forgotPassword, resetPassword }) => {
	const navigate = useNavigate();
	// const [forceConsent, setForceConsent] = useState(false);
	const accessToken = useRef<string | null>("");
	const location = useLocation();
	// const [searchParams, setSearchParams] = useSearchParams();
	

	if (location.pathname === "/reset-password") {
		const vars = new URLSearchParams(location.search);
		if (vars.has("access_token"))
			accessToken.current = vars.get("access_token");
		if (!accessToken.current) navigate("/auth/sign-in");
	}

	// const dispatch = useDispatch();
	// const [showTermsAndConditionsModal, setShowTermsAndConditions] =
	// 	useState(false);
	// const [showPrivecyPolicyModal, setPrivecyPolicy] =
	// 	useState(false);
	// const [userConsent, setUserConsent] = useState(false);
	// const stateSelector = useCallback(stateSelectorHandle, []);
	// const { loading } = useSelector(stateSelector);

	// const handleResetPassword = useCallback(
	// 	async (values: { password: string }) => {
	// 		try {
	// 			await api.auth.resetPassword(
	// 				values.password,
	// 				accessToken.current || "",
	// 			);
	// 			notify(
	// 				"success",
	// 				"Password reset success",
	// 				"You can now login with your new password!",
	// 			);
	// 			navigate("/auth/sign-in");
	// 		} catch (error) {
	// 			console.error({ error });
	// 			notify(
	// 				"error",
	// 				"Password reset failed",
	// 				"Sorry ... we could not update your password",
	// 			);
	// 		}
	// 	},
	// 	[navigate],
	// );

	// const handleForgotPassword = useCallback(
	// 	async (values: { email: string }) => {
	// 		try {
	// 			await api.auth.recover(values.email);
	// 			notify(
	// 				"success",
	// 				"Password reset success",
	// 				"Please check your email! You will find further instructions there!",
	// 			);
	// 			navigate("/auth/sign-in");
	// 		} catch (error) {
	// 			console.error({ error });
	// 			notify(
	// 				"error",
	// 				"Password reset failed",
	// 				"Sorry ... we cannot find an account with that email address",
	// 			);
	// 		}
	// 	},
	// 	[navigate],
	// );

	// const handleSubmit = useCallback(
	// 	(values: { email: any; password: any }) => {
	// 		dispatch(
	// 			authenticate({
	// 				email: values.email,
	// 				password: values.password,
	// 			}),
	// 		);
	// 	},
	// 	[dispatch],
	// );

	// const handleRegister = useCallback(
	// 	(values: {
	// 		email: any;
	// 		password: any;
	// 		firstName: any;
	// 		lastName: any;
	// 	}) => {
	// 		if (userConsent) {
	// 			dispatch(
	// 				register({
	// 					email: values.email,
	// 					password: values.password,
	// 					first_name: values.firstName,
	// 					last_name: values.lastName,
	// 					accepted_tcs: true,
	// 					consented_to_pdp: true,
	// 					is_nested_with_user: true,
	// 				}),
	// 			);
	// 		} else {
	// 			setForceConsent(true);
	// 		}
	// 	},
	// 	[userConsent, dispatch],
	// );

	// const handleUserConsent = useCallback((event: CheckboxChangeEvent) => {
	// 	if (event.target.name === "personalDataUsage") {
	// 		setUserConsent(event.target.checked);
	// 	}
	// }, []);

	// const handleTermsAndConditionsDialog = useCallback(
	// 	(event: React.MouseEvent) => {
	// 		event.stopPropagation();
	// 		event.preventDefault();
	// 		setShowTermsAndConditions(
	// 			(showTermsAndConditionsModal) => !showTermsAndConditionsModal,
	// 		);
	// 	},
	// 	[],
	// );
	// const handlePrivacyPolicyDialog = useCallback(
	// 	(event: React.MouseEvent) => {
	// 		event.stopPropagation();
	// 		event.preventDefault();
	// 		setPrivecyPolicy(
	// 			(showPrivecyPolicyModal) => !showPrivecyPolicyModal,
	// 		);
	// 	},
	// 	[],
	// );

	// const goToPrivacyPolicy = useCallback(() => {
	// 	window.open("https://www.ugenie.io/privacy-policy", "_blank");
	// }, []);



	return (
		<>
			{resetPassword ? (
				<ResetPasswordForm />
			) : forgotPassword ? (
				<ForgetPasswordForm/>
			) : signUp ? (
				<SignUpForm />
			) : (
			<LoginForm />
			)}
			{/* <TermsAndConditionsModal
				visible={showTermsAndConditionsModal}
				handleShowModal={handleTermsAndConditionsDialog}
			/>
			{showPrivecyPolicyModal && 
			<PrivacyPolicyModal 
			visible={showPrivecyPolicyModal} 
			handleShowModal={handlePrivacyPolicyDialog}
			/>} */}
			</>
	);
};

export default memo(AuthenticationBox);
